import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useForm } from "react-hook-form";
import classes from './form.module.scss'

import { useNavigate, useParams } from 'react-router-dom';
import errorMessage from "../../../../../const/Tost";
import { userService } from "../../../../../api/userService";
import {singIn} from "../../../WorkersFolder/AddUser/UserTagData";

const EditUser = () => {
    const { id } = useParams(); // Get the user ID from the URL parameters
    const navigate = useNavigate(); // Initialize navigation function
    const [userInfo, setUserInfo] = useState({}); // State to hold user information

    const [fileName, setFileName] = useState("Оберіть файл");
    const [base64String, setBase64String] = useState("");

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        reset,
    } = useForm(); // Initialize form handling

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);  // Set the file name to display in the label
            const reader = new FileReader();

            reader.onload = () => {
                const base64 = reader.result.split(",")[1];  // Extract the base64 string
                setBase64String(base64);
            };

            reader.readAsDataURL(file);  // Read the file as a data URL (base64)
        }
    };

    // Function to handle form submission
    const onSubmit = async (data) => {
        if(!data?.password) delete data['password'];

        try {
            if (base64String) {
                data['certificate'] = base64String;
            }

            if (data.roleLabel === 'medicalDirector'){
                data['permissions'] = {
                    contracts_manage: false,
                    hospitals_manage: false,
                    users_manage: false,
                    statistic: false,
                    users_activity: false,
                };
            }

            if (data.roleLabel === "admin"){
                data['permissions'] = {
                    contracts_manage: true,
                    hospitals_manage: true,
                    users_manage: true,
                    statistic: true,
                    users_activity: true,
                };
            }


            if (data.roleLabel === "laboratoryAssistant"){
                data['permissions'] = {
                    scaning_print: true,
                }
            }

            if (data.roleLabel === "assistant"){
                data['permissions'] = {
                    scaning_print: false,
                }
            }

            await userService.editUserInfo(id, data).then(res => {
                if (res) navigate('/WorkersList');
            });
        } catch (error) {
            errorMessage(error, error?.response?.data?.message); // Handle errors during submission
        }
    }

    useEffect(() => {
        userService.getUserInfo(id).then(res => {
            if (res?.data) { // Check if data is returned
                setUserInfo(res.data); // Update state with user data
                reset(res.data); // Reset form fields with fetched user data
            }
        })
    }, [id, reset]); // Dependencies: re-run effect if ID or reset function changes

    return (
        <>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                <div className={classes.form__wrapper}>
                    <div className={classNames(classes.form__title)}>
                        Змінити існуючого працівника
                    </div>
                </div>
                {[...singIn.fields]
                    .sort((a, b) => {
                        if (a.name === 'surname' && b.name === 'name') return -1;
                        if (a.name === 'name' && b.name === 'surname') return 1;
                        return 0;
                    }).map((el, index) => ( // Map over fields defined in singIn
                    <div className={classes[singIn.class]} key={index}>
                        <legend className={classes.form__label} htmlFor={el.type}>{el.legend}</legend>
                        <div
                            className={classNames(el.name == 'cassetsAfter' ? classes.form__input__cassets : classes.form__label__container, { [classes.register__container]: singIn.formType == 'singIn' })}>
                            {el.options ? ( // Check if the field has options for a select element
                                <>
                                    <label>{el.label}</label>
                                    <select
                                        name={el.name}
                                        className={classes.form__select}
                                        {...register('roleLabel')}  // регистрируем именно roleLabel
                                        onChange={(e) => {
                                            // при смене выбираем объект по roleLabel
                                            const selectedRoleLabel = e.target.value;
                                            const selectedOption = el.props.find(opt => opt.roleLabel === selectedRoleLabel);

                                            // обновляем значение roleLabel и, если нужно, значение роли
                                            setValue('roleLabel', selectedRoleLabel);
                                            setValue(el.name, selectedOption?.value || '');
                                        }}
                                        defaultValue=""
                                    >
                                        <option value="" disabled>Оберіть роль</option>
                                        {el.props.map((props) => (
                                            <option key={props.id} className={classes.form__option} value={props.roleLabel}>
                                                {props.name}
                                            </option>
                                        ))}
                                    </select>
                                </>
                            ) : (
                                el.props.map((props, i) => (
                                    <div
                                        className={classNames(classes.form__label__container__box, { [classes.register__container]: singIn.formType == 'singIn' })}
                                        key={'a' + i}>
                                        <div><label>{props.label}</label></div> {/* Field label */}
                                        {el.type === 'file' ? (
                                            <div className={classes.form__fileInput__wrapper}>
                                                <label className={classes.form__fileInput__label}>
                                                    {fileName}
                                                    <input
                                                        className={classNames(classes.form__fileInput, {[classes.errorInput]: errors[el.name]})}
                                                        type='file'
                                                        placeholder={props.placeholder}
                                                        onChange={(e) => handleFileChange(e)}
                                                    />
                                                </label>
                                            </div>
                                        ) : (
                                            <div>
                                                <div className={el.name == 'cassetsAfter' ? classes.form__input__cassets : {}}>
                                                    <input
                                                        className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                                                        type={props.type}
                                                        min={props.min}
                                                        max={props.max}
                                                        disabled={props.show}
                                                        placeholder={props.placeholder}
                                                        pattern={props.pattern}
                                                        value={el.type == 'radio' ? props.label : props.value}
                                                        {...register(
                                                            el.name == 'age' || el.name == 'cassetsAfter'
                                                                ? props.register
                                                                : el.name,
                                                            {required: el?.name !== 'password' ?  el.required : null}
                                                        )}
                                                    />
                                                </div>

                                                {errors[el.name] && (
                                                    <p className={classNames('DefaultForm-input-hint', classes.errorHint)}>
                                                        Це поле є обов'язковим
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                ))}
                <button className={classes.form__button} type="submit">Змінити</button> {/* Submit button */}
            </form>
        </>
    );
}

export default EditUser; // Export the component for use in other parts of the application
